import { createSlice } from '@reduxjs/toolkit';
import { getActiveServicesList } from '../../reducers/active/activeThunks';
import { handleRequestThunk } from '../handleRequestThunk';
import { commonInitialState } from '../../../utils/common/commonInitialState';
const SLICE_NAME = 'activeServices';

export const activeServicesListSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getActiveServicesList });
    },
});

export const selectActiveServicesList = (state) => state.activeServices.data;

export const activeServices = activeServicesListSlice.reducer;
